import React from 'react';
import { Route , Redirect} from 'react-router-dom';
import useAuth from '../Utils/useAuth';

export const ProtectedRoute =({ component: Component, ...rest }) =>{
    const { authed ,localStorageData} = useAuth();
    
    return (
      <Route
        {...rest}
        render={routeProps => {
            if((localStorageData!==null && localStorageData!== undefined) || authed){
               return <Component {...routeProps} />
            }else{
                return ( 
                <Redirect 
                to={{
                    pathname: '/',
                    state:{
                        from:routeProps.location
                    },
                }

                } />)
            }

        }}
      />
    );
  }